import { render, staticRenderFns } from "./emailHeader.vue?vue&type=template&id=eaa64b96"
import script from "./emailHeader.vue?vue&type=script&lang=js"
export * from "./emailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports